export type { OptimisedImageProps } from "./optimised-image";
export { OptimisedImage } from "./optimised-image";
